import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface PendingApprovalServiceInterface {
  resolvePendingActivation(
    activationID: string,
    appID: string,
    businessID: string,
    approved: boolean,
    addonID?: string,
    accountID?: string,
    rejectionReason?: string,
  ): Observable<object>;
}

export const PendingApprovalServiceInterfaceToken: InjectionToken<PendingApprovalServiceInterface> =
  new InjectionToken<PendingApprovalServiceInterface>('PendingApprovalServiceInterface');
